import React, { useEffect, useState } from "react";
import { resetSession } from "../../../../redux/auth";
import {
  getRecruitmentTrackerBulkUploadHistoryAction,
  resetBulkUploadHistoryCount,
  resetHrmsError,
  resetHrmsSuccess,
} from "../../../../redux/hrms";
import { resetBulkUploadHistoryData } from "../../../../redux/invoiceGeneration";
import { connect } from "react-redux";
import { RootState } from "../../../../redux/rootReducers";
import { EmptyListPage, ErrorSuccessModal, TableLoader } from "../../../commons";
import { EmptyList } from "../../../../assets/images";
import HRMSBulkUploadTable from "./HRMSBulkUploadTable";
import { GetGenerateSasTokenPayloadType } from "../../../../commonTypes/stcoToolsType";
import {
  getTokenGenerateForDownloadAction,
  resetSasTokenForDownloadFile,
} from "../../../../redux/stcoTools";
import { GetHrmsBulkUploadHistoryPayloadType } from "../../../../commonTypes/hrmsTypes";

type AppProps = {
  history: any;
  activeTab: any;
  fetching: boolean;
  success: null | number;
  error: null | string;
  statusCode: null | number;
  token: null | string;
  bulkUploadHistoryCount: number;
  bulkUploadHistoryData: any[] | [];
  dispatchResetSession: () => void;
  dispatchResetListingError: () => void;
  dispatchResetListingSuccess: () => void;
  dispatchResetBulkUploadHistoryData: () => void;
  dispatchGetBulkUploadHistoryData: (data: GetHrmsBulkUploadHistoryPayloadType) => void;
  dispatchResetBulkUploadHistoryCount: () => void;
  dispatchGetTokenGenerateForDownloadAction: (
    data: GetGenerateSasTokenPayloadType
  ) => void;
  dispatchResetSasTokenForDownloadFile: () => void;
  sasTokenForDownloadFile: string;
};
const HRMSBulkUpload = ({
  history,
  activeTab,
  fetching,
  success,
  error,
  statusCode,
  token,
  bulkUploadHistoryCount,
  bulkUploadHistoryData,
  dispatchResetSession,
  dispatchResetListingError,
  dispatchResetListingSuccess,
  dispatchResetBulkUploadHistoryData,
  dispatchGetBulkUploadHistoryData,
  dispatchResetBulkUploadHistoryCount,
  dispatchGetTokenGenerateForDownloadAction,
  dispatchResetSasTokenForDownloadFile,
  sasTokenForDownloadFile,
}: AppProps) => {
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(20);

  const [data, setData] = useState<any[]>([]);


  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
    });

    dispatchResetBulkUploadHistoryData();
    dispatchResetListingError();
    dispatchResetListingSuccess();
    dispatchResetBulkUploadHistoryCount();
  }, []);

  useEffect(() => {
    if (bulkUploadHistoryData?.length === 0) {
      setData(bulkUploadHistoryData);
    }
    if (offset > 0) {
      setData((prv: any) => [...prv, ...bulkUploadHistoryData]);
    } else {
      setData(bulkUploadHistoryData);
    }
  }, [bulkUploadHistoryData]);

  useEffect(() => {
    dispatchResetListingSuccess();
    dispatchResetListingError();
    if (token) {
      let finalData: GetHrmsBulkUploadHistoryPayloadType = {
        token,
        limit,
        offset,
      };

      if (bulkUploadHistoryCount) {
        if (offset < bulkUploadHistoryCount) {
          dispatchGetBulkUploadHistoryData(finalData);
        }
      } else {
        dispatchGetBulkUploadHistoryData(finalData);
      }
    }
  }, [offset]);

  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      if (
        offset < bulkUploadHistoryCount &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (bulkUploadHistoryData?.length > 0) {
          if (!fetching && offset < bulkUploadHistoryCount) {
            setOffset(offset + limit);
          }
        }
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [bulkUploadHistoryData]);


  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetListingError();
            }}
          />
        );
      }
    }

    return false;
  };

  return (
    <div className="">
      <div className="jobs-card">
        <div className="header">
          <div className="left-header">
            <div className="heading mb-0 mt-0">HRMS Bulk Upload History</div>
            <div className="sub-heading">{`Total ${
              bulkUploadHistoryCount ? bulkUploadHistoryCount : 0
            } list found`}</div>
          </div>

          <div className="right-header"></div>
        </div>

        <div>
          {fetching && offset == 0 ? (
            <TableLoader Rows={10} ColumnPerRow={7} />
          ) : bulkUploadHistoryData?.length > 0 ? (
            <HRMSBulkUploadTable
              data={data}
              fetching={fetching}
              offset={offset}
              sasTokenForDownloadFile={sasTokenForDownloadFile}
              dispatchResetSasTokenForDownloadFile={
                dispatchResetSasTokenForDownloadFile
              }
              dispatchGetTokenGenerateForDownloadAction={
                dispatchGetTokenGenerateForDownloadAction
              }
              token={token}
            />
          ) : (
            <div className="mt-5 pb-5">
              {!fetching && data?.length === 0 && (
                <EmptyListPage
                  title="No List Found!"
                  image={EmptyList}
                  imageWidth="30%"
                />
              )}
            </div>
          )}
        </div>
      </div>
      {handleErrorModal()}

    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  success: state.hrms.success,
  fetching: state.hrms.fetching,
  statusCode: state.hrms.statusCode,
  error: state.hrms.error,
  bulkUploadHistoryData: state.hrms.bulkUploadHistoryData,
  bulkUploadHistoryCount: state.hrms.bulkUploadHistoryCount,
  sasTokenForDownloadFile: state.stcoTools.sasTokenForDownloadFile,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetListingError: () => dispatch(resetHrmsError()),
  dispatchResetListingSuccess: () => dispatch(resetHrmsSuccess()),
  dispatchResetBulkUploadHistoryData: () =>
    dispatch(resetBulkUploadHistoryData()),
  dispatchGetBulkUploadHistoryData: (data: GetHrmsBulkUploadHistoryPayloadType) =>
    dispatch(getRecruitmentTrackerBulkUploadHistoryAction(data)),
  dispatchResetBulkUploadHistoryCount: () =>
    dispatch(resetBulkUploadHistoryCount()),
  dispatchGetTokenGenerateForDownloadAction: (
    data: GetGenerateSasTokenPayloadType
  ) => dispatch(getTokenGenerateForDownloadAction(data)),
  dispatchResetSasTokenForDownloadFile: () =>
    dispatch(resetSasTokenForDownloadFile()),
});

export default connect(mapStateToProps, mapDispatchToProps)(HRMSBulkUpload);
